import * as React from "react";
import {faSearch}                       from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon}                from "@fortawesome/react-fontawesome";

import "./office-management-layout.scss";

import {cs}                           from "@Common/react/chain-services";
import {consumeContext}               from "@Common/react/context";
import {UseState}                     from "@Common/react/use-state";
import {SliderCheckbox}               from "@Common/ui-components/slider-checkbox/slider-checkbox";
import {Responsive}                   from "@Common/ui-components/responsive";
import {parseUrlQuery}                from "@Common/utils/parse-url-query";
import {removeURLParameterFromWindow} from "@Common/utils/remove-url-parameter";

import {OfficeFilterBar}       from "./office-filter-bar";
import {navigateToSearchStart} from "./office-filter-bar";
import {OfficeCard}            from "./office-management-card";

const SHOW_INACTIVE_OFFICES = "showInactiveOffices";

export const OfficeManagementLayout = ({offices}) => cs(
    consumeContext("company"),
    consumeContext("userLevels"),
    consumeContext("routerHistory"),
     // @ts-ignore
     ["responsive", ({}, next) => <Responsive {...{
        sizes: {
            md: 1024,
        },
        next,
    }}/>],
    ["query", ({}, next) => next(parseUrlQuery(window.location.search))],
    ["searchState", ({}, next) => UseState({next, initValue: ""})],
    ["showingInactive", (...[, next]:any[]) => UseState({next, initValue: showInactive(localStorage.getItem(SHOW_INACTIVE_OFFICES))})],
    ["filteredOffices", ({searchState, showingInactive, userLevels, query}, next) => next(
        offices?.value?.filter(office => {
            if (!showingInactive.value && !office.branchActive) {
                return null
            }
            return criterionSurvivesFilter(searchState?.value === "" ?  query?.search ?? "" : searchState?.value, office, userLevels.internalUser)
        })
    )],
    ["sortedOffices", ({filteredOffices}, next) => next(
        filteredOffices?.sort((officeOne, officeTwo) => {
            const nameOne = officeOne['branchName'].toLowerCase()
            const nameTwo = officeTwo['branchName'].toLowerCase()
            const sortedOnBackend = 0

            if (!nameOne) {
                return 1
            }

            if (!nameTwo) {
                return -1
            }
            return sortedOnBackend
        })
    )],

    ({company, filteredOffices, searchState, showingInactive, sortedOffices, query, responsive, routerHistory}) => (
        <div className="office-management-layout-NaOH">
            <div className="filters-ui">
                <div className="offices-search">
                    <label className="slider-label"><span className="text"
                        xd-qa-type="label" xd-qa-name="Show Inactive">Show Inactive</span>
                        <SliderCheckbox
                            disabled={offices.loading}
                            onChange={() => {
                                localStorage.setItem(SHOW_INACTIVE_OFFICES, showInactive(!showingInactive.value))
                                showingInactive.onChange(!showingInactive.value)
                            }}
                            value={showingInactive.value}
                            xdQaName={showInactive(showingInactive.value) ? "Show Inactive Slider true" : "Show Inactive Slider false"}
                        />
                    </label>
                    <div className={`input-with-button`}>
                        <input
                            type="text"
                            disabled={offices.loading}
                            value={searchState.value}
                            onChange={(e) => {
                                updateSearch(query, searchState, e.currentTarget.value)
                            }}
                            placeholder="Search for an office"
                            xd-qa-type="textbox"
                            xd-qa-name="Search for an office"
                        />
                        <button>
                            {
                                !searchState.value &&
                                <FontAwesomeIcon icon={faSearch} />
                            }
                        </button>
                    </div>
                </div>
                {
                    responsive.ge("md") ? (
                        <OfficeFilterBar selections={lettersArray} sortedOffices={sortedOffices} viewAllFn={() => updateSearch(query, searchState, '')}/>
                    ) : (
                        null
                    )
                }
            </div>
            <div className="grid-offices">
                {
                    ((!offices.loading || offices.value?.length > 0) && company?.prefs.signupCreateBranch)
                    &&
                    <div className="item item-office-new">
                        <button aria-label="CREATE NEW OFFICE"
                                xd-qa-type="button"
                                xd-qa-name="CREATE NEW OFFICE"
                                onClick={() => (
                                    routerHistory.replace('/account/admin/office?modal=create&step=general')
                                )}
                        >
                            CREATE NEW OFFICE
                        </button>
                    </div>
                }
                {
                    !offices.loading && filteredOffices.map((office, i) => (
                        <React.Fragment key={i} >
                            {OfficeCard({office: office, query, routerHistory})}
                        </React.Fragment>
                    ))
                }
            </div>
        </div>
    )
);

function updateSearch(query, searchState, value) {
    navigateToSearchStart()
    if(query) query.search = ""
    removeURLParameterFromWindow({parameter: "search"})
    searchState.onChange(value)
}

const characterArray = () => {
    const characters = [];
    const A_ASCII = 65;
    const Z_ASCII = 90;
    for(let i = A_ASCII; i < Z_ASCII + 1; i++) {
        characters.push(String.fromCharCode(i))
    }

    return characters
}

const lettersArray = characterArray();

const showInactive = (valueBoolean) => {
    if(valueBoolean) {
        return "showInactive"
    }

    return ""
}

const criterionSurvivesFilter = (criterion, office, internalUser) => {
    const criterionLowerCase = criterion.toLowerCase().trim();
    const searchFieldsValid = [
        'branchName',
        'branchAddress1',
        'branchAddress2',
        'branchCity',
        'branchZip',
        'branchState',
        'branchLinkId',
        'idBranch' // Allow for internal users only.
    ]
    const SEARCH_INDEX_MAX = internalUser ? searchFieldsValid.length : searchFieldsValid.length - 1
    for(let i = 0; i < SEARCH_INDEX_MAX; i++) {
        if (office[searchFieldsValid[i]].toLowerCase().includes(criterionLowerCase)) {
            return true
        }
    }
    return false
}
